import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/outdoor/swiss-army-knife.png";
import type { Product } from "../../types";
import { wifiOutdoor } from "../product-list-groups/wifiOutdoor";
import { extendedRangeMode6Ghz, radio6Ghz, wifiMounting } from "../properties";
import { antennaType } from "../properties/antennaType";
import { connectedDevices } from "../properties/connectedDevices";
import { wifiCoverage } from "../properties/coverage";
import { externalAntennaSupport } from "../properties/externalAntennaSupport";
import { uplink } from "../properties/uplink";
import { wifiTechnology } from "../properties/wifiTechnology";

export const swissArmyKnifeUltra: Product = {
  id: "swissArmyKnifeUltra",
  productTitle: "Swiss Army Knife",
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.WiFi}/uk-ultra`],
  storePathParts: {
    productSlug: "uk-ultra",
    category: UniFiChildCategorySlug.WiFiOutdoor,
  },
  sku: "UK-Ultra",
  description: "swissArmyKnifeUltra.description",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiOutdoor,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '137 x 84 x 34 mm\n(5.4 x 3.3 x 1.3")',
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "swissArmyKnifeUltra.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: extendedRangeMode6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: antennaType.id,
      value: {
        type: "translation",
        value: "swissArmy.antennaType.omnidirectional",
        asterisk: 1,
      },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "115 m² (1,250 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "200+" },
    },
    {
      propertyId: externalAntennaSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE" },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "swissArmyKnifeUltra.uplink" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "swissArmyKnifeUltra.mounting.1",
        asterisk: 2,
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "string", value: "IPX6" },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
  notes: [
    "swissArmyKnifeUltra.notes.externalAntenna",
    "swissArmyKnifeUltra.notes.mounting",
  ],
};
